import { Box } from '@mui/material'
import { useTranslation } from 'react-i18next'

export type AutoManualLedProps = {
  manual: boolean
  error: boolean
  disabled?: boolean
}

export function AutoManualLed(props: AutoManualLedProps): React.ReactElement {

  const { manual, error, disabled } = props
  const { t } = useTranslation()

  let color, bgColor

  if (error) {
    color = disabled ? 'gray' : 'white'
    bgColor = disabled ? 'black' : 'error.main'
  } else {
    if (manual) {
      color = disabled ? 'gray' : 'black'
      bgColor = disabled ? 'black' : 'white'
    } else {
      color = 'transparent'
      bgColor = 'transparent'
    }
  }

  return (
    <Box
      display="inline-block"
      sx={{
        width: '1rem',
        height: '1rem',
        color,
        backgroundColor: bgColor,
        borderRadius: '3px',
        textAlign: 'center',
        fontWeight: 800,
        lineHeight: '1rem'
      }}
    >
      {error ? t('Icon-Error') : (manual ? t('Icon-Manual') : t('Icon-Automatic')) }
    </Box>
  )
}
